import React, { useEffect } from "react";
import FileIconGray from "../Pages/ClientDashboard/Details/Kyc/FileIconGray";
import noDataIcon from "../asset/images/icons/no-data-icon.svg";
import { Constants } from "./Constants";
import * as CryptoJS from "crypto-js";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { AP_Payout_Rms , Partner_Payout_Rms } from "../Configuration/API_URL";
import { toast } from "react-toastify";
import moment from "moment";

// handling sidebar
export const toggleSidebar = () => {
  let sidebar = document.getElementById("sidenav");
  let body = document.getElementById("root");
  document.querySelectorAll(".side-blue").forEach((el) => {
    if (el.childNodes[1]) {
      el.childNodes[1].style.display = "block";
    }
    if (el.childNodes[0]) {
      el.childNodes[0].style.display = "block";
    }
  });
  sidebar.classList.add("toggle-nav");
  body.classList.add("show-overlay");
};

export const noDataFound = (noData = "No Data Available", style = {}) => {
  return (
    <div style={style} className="no-data">
      <img src={noDataIcon} alt="No Data Icon" />
      <span>{noData}</span>
    </div>
  );
};
export const noDataMFFound = (noData = "No Data Available") => {
  return (
    <div className="no-data mf-er">
      <img src={noDataIcon} alt="No Data Icon" />
      <span>{noData}</span>
    </div>
  );
};
export const errData = (noData) => {
  return (
    <div className="err-data">
      <img src={noDataIcon} alt="No Data Icon" />
      <span>{noData}</span>
    </div>
  );
};
export const noNomineeFound = () => {
  return (
    <div className="no-data">
      <img src={noDataIcon} alt="No Data Icon" />
      <span>Nominee is not available</span>
    </div>
  );
};

export const commingSoon = () => {
  return (
    <div className="no-data">
      <span className="coming-soon">{Constants.Coming_Soon}</span>
    </div>
  );
};

export const mobileVal = (e) => {
  var k = e.charCode;
  if ((k >= 48 && k <= 57) || k === 8) {
    if (e.target.value.length === 0) {
      if (k >= 54 && k <= 57) {
      } else {
        e.preventDefault();
      }
    }
    return true;
  } else {
    e.preventDefault();
  }
};

export const onlyNumberSharing = (e) => {
  let length = e.target.value.length;
  let existingValue = e.target.value.slice(0, length - 1);
  let regex1 = /^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/;
  if (!e.target.value.match(regex1)) {
    e.target.value = existingValue;
  }
};
export const onlyNumber = (e) => {
  let length = e.target.value.length;
  let existingValue = e.target.value.slice(0, length - 1);
  let num1 = /^[0-9]*$/;
  if (!e.target.value.match(num1)) {
    e.target.value = existingValue;
  }
};
export const onlyNumberLess100 = (e) => {
  let length = e.target.value.length;
  let existingValue = e.target.value.slice(0, length - 1);
  let regex2 = /^(\d{0,2}(\.\d{1,2})?)$/;
  if (!e.target.value.match(regex2)) {
    e.target.value = existingValue;
  }
};

export const onlyNumber5Digit2Decimal = (e) => {
  let length = e.target.value.length;
  let existingValue = e.target.value.slice(0, length - 1);
  let regex4 = /^(\d{0,5}(\.\d{1,2})?)$/;
  if (!e.target.value.match(regex4)) {
    e.target.value = existingValue;
  }
};

export const goToClientDashboard = (clientCode, pan) => {
  if (clientCode) {
    localStorage.setItem("clientCode", clientCode);
    localStorage.setItem("clientPan", pan);
  } else {
    localStorage.setItem("clientPan", pan);
    localStorage.setItem("clientCode", "");
  }
};
export const getTabStatus = (tab) => {
  if (tab) {
    localStorage.setItem("tabOnboarding", tab);
  } else {
    localStorage.setItem("tabOnboarding", "");
  }
};
export const getPartnerId = (id) => {
  if (id) {
    localStorage.setItem("PartnerId", id);
  } else {
    localStorage.setItem("PartnerId", "");
  }
};
export const getInvoiceId = (Id) => {
  if (Id) {
    localStorage.setItem("invoiceId", Id);
  } else {
    localStorage.setItem("invoiceId", "");
  }
};

export const getName = (name) => {
  if (typeof name === "string") {
    if (name.length > 0) {
      let nameArray = name.trim().split(" ");
      if (nameArray.length > 1) {
        let firstLetter = nameArray[0].charAt(0);
        let lastLetter = nameArray[nameArray.length - 1].charAt(0);
        return firstLetter + lastLetter;
      } else {
        let firstLetter = nameArray[0].charAt(0);
        return firstLetter;
      }
    } else {
      return "-";
    }
  }
};

export const startTrimString = (e) => {
  e.target.value = e.target.value.trimStart();
};
export const allTrim = (e) => {
  e.target.value = e.target.value.replaceAll(" ", "");
};
export const nameFirstLetter = (e) => {
  if (e.target.value.length >= 1) {
    if (e.target.value.charAt(0) === ".") {
      e.target.value = e.target.value.slice(1, e.target.value.length);
    }
  }
};
export const handleInputChange = (e) => {
  if (e.target.value.length >= 1) {
    if (!["6", "7", "8", "9"].includes(e.target.value.charAt(0))) {
      e.target.value = e.target.value.slice(1, e.target.value.length);
    }
  }
  e.target.value = e.target.value.replace(/[^0-9]/g, "");
}
export const validateEmail = (email) => {
  let emailRegex =
    /([-!#-'*+/-9=?A-Z^-~]+(\.[-!#-'*+/-9=?A-Z^-~]+)*|"([]!#-[^-~ \t]|(\\[\t -~]))+")@([0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?(\.[0-9A-Za-z]([0-9A-Za-z-]{0,61}[0-9A-Za-z])?)*|\[((25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3}|IPv6:((((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){6}|::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){5}|[0-9A-Fa-f]{0,4}::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){4}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):)?(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){3}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,2}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){2}|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,3}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,4}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])(\.(25[0-5]|2[0-4][0-9]|1[0-9]{2}|[1-9]?[0-9])){3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,5}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3})|(((0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}):){0,6}(0|[1-9A-Fa-f][0-9A-Fa-f]{0,3}))?::)|(?!IPv6:)[0-9A-Za-z-]*[0-9A-Za-z]:[!-Z^-~]+)])/g;
  // /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (email.length > 0) {
    return emailRegex.test(email);
  } else {
    return false;
  }
};

export const checkEmpty = (value) => {
  if (value == undefined || null) return true;
  else return false;
};

export function checkString(value) {
  // if (value) {
  //   if (value.length > 0 && value !=undefined && value !==null) {
  //     return value.toString().trim();
  //   } else {
  //     return "NA";
  //   }
  // } else {
  //   return "NA";
  // }

  try {
    if (value == undefined || null) {
      return "NA";
    } else {
      let result = value.toString().trim();
      if (result.length > 0) return value;
      else return "NA";
    }
  } catch (e) {
    console.log(e);
    return "NA";
  }
}

export function checkStringNew(value) {
  try {
    if (value == undefined || null) {
      return "-";
    } else {
      let result = value.toString().trim();
      if (result.length > 0) return value;
      else return "-";
    }
  } catch (e) {
    console.log(e);
    return "-";
  }
}

export function checkBoolean(value) {
  try {
    if (value == undefined || null) {
      return false;
    } else {
      if (typeof value == "boolean") {
        return value;
      } else {
        return false;
      }
    }
  } catch (e) {
    console.log(e);
    return "NA";
  }
}

export const truncate = (input) =>
  input.length > 17 ? `${input.substring(0, 14)}...` : input;

export function checkDocument(getDocumentsApi, value) {
  try {
    if (value == undefined || null) {
      return <FileIconGray />;
    } else {
      let result = value.trim();
      if (result.length > 0) {
        return (
          <>
            <a onClick={() => getDocumentsApi(value)}>
              <span className="color-green site-icons icon-pdf"></span>
            </a>
          </>
        );
      } else return <FileIconGray />;
    }
  } catch (e) {
    console.log(e);
    return <FileIconGray />;
  }
}

export const checkValue = (value) => {
  if (checkEmpty(value)) {
    return false;
  } else {
    if (typeof value == "number") {
      return true;
    } else {
      return false;
    }
  }
};

export const emailX = (email) => {
  let DualEMail = email.split("@");
  let beforeEmail;
  if (DualEMail[0].length > 6) {
    // beforeEmail = mobileNumber(DualEMail[0]);
    let fourChar = DualEMail[0].slice(-4);
    let twoChar = DualEMail[0].slice(0, 2);
    let lenthtoX = Array(DualEMail[0].length - 5).join("X");
    beforeEmail = twoChar + lenthtoX + fourChar;
  } else if (DualEMail[0].length > 1 && DualEMail[0].length <= 4) {
    let numbershow = DualEMail[0].slice(0, 1);
    let lengthtoX = Array(DualEMail[0].length).join("X");
    beforeEmail = numbershow + lengthtoX;
  } else if (DualEMail[0].length > 4 && DualEMail[0].length < 7) {
    let lastTwoChar = DualEMail[0].slice(-2);
    let beforeTwoChar = DualEMail[0].slice(0, 2);
    let lenthtoX = Array(DualEMail[0].length - 3).join("X");
    beforeEmail = beforeTwoChar + lenthtoX + lastTwoChar;
  } else {
    beforeEmail = DualEMail[0];
  }

  return `${beforeEmail}@${DualEMail[1]}`;
};
export const mobileNumber = (value) => {
  if (value) {
    let numberToshow = value.slice(-4);
    let lenthtoX = Array(value?.length - 3).join("X");
    return lenthtoX + numberToshow;
  }
};

// export const mobileNumber = (mobile) => {
//   let encodeDigit = "XXXXXX";
//   let last4Digits = mobile.substring(6);
//   let contactNumber = encodeDigit + last4Digits;
//   return contactNumber;
// };
export const checkInt = (val) => {
  let isValid = false;
  // if (val) isValid = /^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/.test(val);
  if (val) isValid = /^(\d{0,2}(\.\d{1,2})?|100?)$/.test(val);
  return isValid;
};

// export const checkInt = (val) => {
//   let isValid = false;
//   if (val) isValid = /^(\d{0,2}(\.\d{1,2})?|100(\.00?)?)$/.test(val);

//   return isValid;
// };

export const convertToFloat = (value) => {
  if (value) value = parseFloat(value).toFixed(2);
  return value;
};

export const splitDateSlash = (createddatetime) => {
  let date = createddatetime?.split(" ")[0];
  return date?.split("/").join("-");
};

export const splitYear = (createddatetime) => {
  if (createddatetime) {
    if (createddatetime.includes("-")) {
      return createddatetime.split(" ")[0].split("-")[2];
    } else if (createddatetime.includes("/")) {
      return createddatetime.split(" ")[0].split("/")[2];
    }
  }
};

export const splitDate = (createddatetime) => {
  let date = createddatetime?.split("T")[0];
  return date?.split("-")?.reverse()?.join("-");
};
export const partnerDob = (value) => {
  let dob = value?.split("T")[0];
  return dob;
};

export const getFrenchiseeId = (id) => {
  if (id) {
    localStorage.setItem("frenchiseeId", id);
  } else {
    localStorage.setItem("frenchiseeId", "");
  }
};
export const getCompliacnceId = (id) => {
  if (id) {
    localStorage.setItem("complianceId", id);
  } else {
    localStorage.setItem("complianceId", "");
  }
};
export const splitDateNew = (splitdatetime) => {
  let date = splitdatetime.split("T").join(" ");
  let sec = date.slice(0, 19);
  let DateTimeArr = sec.split(" ");

  let [aDate, aTime] = DateTimeArr;

  aDate = aDate.split("-").reverse().join("-");

  return `${aDate} ${aTime}`;
  // return date.split("-").join("-");
};

export const checkDateRange = (fromDate, toDate) => {
  const checkFromDate = new Date(fromDate.toString().replace(/-/g, "/"));
  const checkToDate = new Date(toDate.toString().replace(/-/g, "/"));
  console.log("date range", fromDate, toDate, checkFromDate <= checkToDate, checkFromDate, checkToDate)
  if (checkFromDate <= checkToDate) {
    return true;
  } else {
    return false;
  }
};

export const compareDate = (date) => {
  var now = new Date();
  const checkCurrentData = new Date(now.toString().replace(/-/g, "/"));
  const checkInputDate = new Date(date.toString().replace(/-/g, "/"));
  return checkInputDate <= checkCurrentData;
};

//for capitalize
export const getIV = () => {
  return process.env.REACT_APP_IV
}
export const getSecret = () => {
  return process.env.REACT_APP_SECRET
}
export function capitalize(word) {
  const lower = word.toLowerCase();
  return word.charAt(0).toUpperCase() + lower.slice(1);
}

export function encyptPayload(payload) {
  // const lower = word.toLowerCase();
  // return word.charAt(0).toUpperCase() + lower.slice(1);
  const clientReq = JSON.stringify(payload);
  // const iv = "dCdGXZaOSMegBAHi";
  // const key = "YVTMmqbJG3qRxpJL";
  // const fkey = CryptoJS.enc.Utf8.parse(key);
  // const fiv = CryptoJS.enc.Utf8.parse(iv);
  const iv = getIV();
  const key = getSecret();
  const fkey = CryptoJS.enc.Utf8.parse(atob(key));
  const fiv = CryptoJS.enc.Utf8.parse(atob(iv));
  const encResReq = CryptoJS.AES.encrypt(clientReq, fkey, {
    iv: fiv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString();
  return encResReq;
}


export function decriptResponse(data) {
  // const iv = "dCdGXZaOSMegBAHi";
  // const key = "YVTMmqbJG3qRxpJL";
  // const fkey = CryptoJS.enc.Utf8.parse(key);
  // const fiv = CryptoJS.enc.Utf8.parse(iv);
  const iv = getIV();
  const key = getSecret();
  const fkey = CryptoJS.enc.Utf8.parse(atob(key));
  const fiv = CryptoJS.enc.Utf8.parse(atob(iv));
  let adminReqRes = CryptoJS.AES.decrypt(data, fkey, {
    iv: fiv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
  let adminResponse = JSON.parse(JSON.parse(adminReqRes));
}


export const headearNameWithPath = (pathname) => {
  let HeaderName;
  switch (pathname) {
    case "/dashboard":
      HeaderName = "Dashboard";
      break;
    case "/onboarding":
      HeaderName = "Onboarding";
      break;
    case "/client-support":
      HeaderName = "Client Support";
      break;
    case "/rm-mapping":
      HeaderName = "RM Mapping";
      break;
    case "/ap-master":
      HeaderName = "AP Master";
      break;
    case "/rms":
      HeaderName = "RMS";
      break;
    case "/single-holding":
      HeaderName = "Single holding Report";
      break;
    case "/contact-us":
      HeaderName = "Contact Us";
      break;
    case "/hierarchy-report":
      HeaderName = "Hierarchy Report";
      break;
    case "/aum-report":
      HeaderName = "AUM Report";
      break;
    case "/revenue-report":
      HeaderName = "Revenue Report";
      break;
    case "/ledger-report":
      HeaderName = "Financial Ledger Report";
      break;
    case "/combine-ledger-report":
      HeaderName = "Combine Ledger Report";
      break;
    case "/partner/combine-ledger-report":
      HeaderName = "Combine Ledger Report";
      break;
    case "/tradeSummary-report":
      HeaderName = "Trade Summary Report";
      break;
    case "/partner/tradeSummary-report":
      HeaderName = "Trade Summary Report";
      break;
    case "/p&l-report":
      HeaderName = "P&L Report";
      break;
    case "/itr-report":
      HeaderName = "ITR Report";
      break;
    case "/partner/p&l-report":
      HeaderName = "P&L Report";
      break;
    case "/contract-notes":
      HeaderName = "Contract Notes";
      break;
    case "/levies-report":
      HeaderName = "Levies Report";
      break;
    case "/dividend-report":
      HeaderName = "Dividend Report";
      break;
    case "/clientwise-revenue-report":
      HeaderName = "Client Wise Revenue Report";
      break;
    case "/morning-limits":
      HeaderName = "Morning Limit Report";
      break;
    case "/globalreport":
      HeaderName = "Global Report";
      break;
    case "/client-holding":
      HeaderName = "Client holding Report";
      break;
    case "/partner/client-holding":
      HeaderName = "Client holding Report";
      break;
    case "/interest-report":
      HeaderName = "Interest Report";
      break;
    case "/partner/interest-report":
      HeaderName = "Interest Report";
      break;
    case "/tax-report":
      HeaderName = "Tax Report";
      break;
    case "/dp-transaction-report":
      HeaderName = "DP Transaction";
      break;
    case "/partner/dp-transaction-report":
      HeaderName = "DP Transaction";
      break;
    case "/yield-report":
      HeaderName = "Yield Report";
      break;
    case "/mtf-details-report":
      HeaderName = "MTF Details Report";
      break;
    case "/partner/mtf-details-report":
      HeaderName = "MTF Details Report";
      break;
    case "/delaypayment-report":
      HeaderName = "Delay Payment Report";
      break;
    case "/partner/delaypayment-report":
      HeaderName = "Delay Payment Report";
      break;
    // case "/ltcg-report":
    //   HeaderName = "LTCG Report";
    //   break;
    case "/daysToLongTerm-report":
      HeaderName = "Days To Long Term Report";
      break;
    case "/aging-report":
      HeaderName = "Aging Report";
      break;
    case "/client-dashboard":
      HeaderName = "Client Dashboard";
      break;
    case "/telecaller":
      HeaderName = "Telecaller";
      break;
    case "/pledge":
      HeaderName = "Pledge";
      break;
    case "/ap-payout":
      HeaderName = "AP Payout";
      break;
    // case "/soa-report":
    //   HeaderName = "SOA Report";
    //   break;
    // case "/ivr-report":
    //   HeaderName = "IVR Report";
    //   break;
    case "/telecallerPage":
      HeaderName = "TelecallerPage";
      break;
    case "/LeadsRejectionDashboard":
      HeaderName = "Leads Rejection Dashboard";
      break;
    case "/Telecaller360":
      HeaderName = "Telecaller360";
      break;
    case "/packupgrade":
      HeaderName = "Pack Upgrade";
      break;
    case "/call-download-Report":
      HeaderName = "Recording Report";
      break;
    case "/call-recording-report":
      HeaderName = "Download Report";
      break;
    case "/off-market":
      HeaderName = "Off-Market Trade Date Update";
      break;

    // case "/main":
    //   HeaderName = "Main";
    //   break;
    case "/banking":
      HeaderName = "Banking";
      break;
    case "/finance-rights":
      HeaderName = "Finance Rights";
      break;
    case "/tentative-margin":
      HeaderName = "Tentative Margin Report";
      break;
    case "/margin-shortage-report":
      HeaderName = "Margin Shortage Report";
      break;
    case "/hni-home":
      HeaderName = "HNI Home";
      break;
    case "/hni-rejected-list":
      HeaderName = "HNI Rejection List";
      break;
    case "/hni-client-details":
      HeaderName = "HNI Client Details";
      break;
    case "/retail-home":
      HeaderName = "Retail Home";
      break;
    case "/retail-rejected-list":
      HeaderName = "Retail Rejection List";
      break;
    case "/retail-client-details":
      HeaderName = "Retail Client Details";
      break;
    case "/income-declaration":
      HeaderName = "Income Declaration";
      break;
    case "/fund-transaction":
      HeaderName = "Fund Transaction";
      break;
    case "/cost-report":
      HeaderName = "Cost Report";
      break;
    case "/last-10-transaction-report":
      HeaderName = "View Last 10 Transaction Report";
      break;
    case "/pledge-master-report":
      HeaderName = "Pledge Master Report";
      break;
    case "/family-master":
      HeaderName = "Family Master";
      break;
    case "/ipo-master":
      HeaderName = "IPO Master";
      break;
    case "/freezeUnfreeze":
      HeaderName = "FreezeUnfreeze";
      break;
    case "/application-review":
      HeaderName = "Application Review";
      break;
    case "/partner-application":
      HeaderName = "Application Status";
      break;
    case "/franchisee-onboarding":
      HeaderName = "Application Review";
      break;
    case "/franchisee-application":
      HeaderName = "Application Status";
      break;
    // partner Admin and partner side journey
    case "/partner-side-contact-us":
      HeaderName = "Partner Contact Us";
      break;
    case "/referral-link":
      HeaderName = "Referral Link";
      break;
    case "/partner-invoice":
      HeaderName = "Partner Invoice";
      break;
    case "/invoice":
      HeaderName = "Admin Invoice";
      break;
    case "/partner-admin-onboarding":
      HeaderName = "Demat Lead Tracking";
      break;
    case "/partner-side-dashboard":
      HeaderName = "Partner Dashboard";
      break;
    case "/personal-details":
      HeaderName = "Variable Account Mapping";
      break;
    case "/partner-master":
      HeaderName = "Partner Master";
      break;
    case "/partner-dashboard":
      HeaderName = "Partner Dashboard";
      break;

    // partner admin Dashboard
    case "/partner-admin-dashboard":
      HeaderName = "Dashboard";
      break;

    case "/partner-details-dashboard":
      HeaderName = "Partner Details";
      break;
    case "/compliance-dashboard":
      HeaderName = "Application Review";
      break;
    case "/compliance-application":
      HeaderName = "Compliance Status";
      break;

    // iba-cases
    case "/payoutApproval":
      HeaderName = "Payout Approval";
      break;

    case "/agentPerformance":
      HeaderName = "Agent Performance";
      break;
    case "/communicationHub":
      HeaderName = "Communication Hub";
      break;
    case "/trainingRepository":
      HeaderName = "Training Repository";
      break;
    // case "/agentDetails":
    //   HeaderName = "Agent Details";
    //   break;
    case "/payout-approval":
      HeaderName = "Payout Approval";
      break;
    case "/overview":
      HeaderName = "Overview";
      break;
    case "/generatelink":
      HeaderName = "Generate Link";
      break;
    case "/approvebrokerage":
      HeaderName = "Approve Brokerage";
    case "/telecallerHni":
      HeaderName = "HNI Telecaller Page";
      break;
    case "/hniDashboard":
      HeaderName = "HNI Admin Dashboard";
      break;
    case "/telecallerHniLead":
      HeaderName = "HNI Lead Dashboard";
      break;
    case "/fno-loss":
      HeaderName = "Client F&O Loss";
      break;
    case "/mtfpos":
      HeaderName = "MTF POS Report";
      break;
    case "/hierarchy":
      HeaderName = "Hierarchy"
      break;
    case "/mutualfunds":
      HeaderName = "Mutual Funds"
      break;
    case "/mfreports":
      HeaderName = "Mutual Fund Reports"
      break;
    case "/fnodelivery":
      HeaderName = "FNO Delivery Report"
      break;
    case "/leadcreation":
      HeaderName = "Lead Creation";
      break;
    case "/overview":
      HeaderName = "Overview";
      break;
    case "/iba-agentDetails":
      HeaderName = "Agent Details";
      break;
    case "/agent-personalDetails":
      HeaderName = "Personal Details";
      break;
    case "/performance-reports":
      HeaderName = "Performance Reports";
      break;
    case "/mtfpmrreport":
      HeaderName = "MTF PMR Report";
      break;
    case "/ipodocument":
      HeaderName = "IPO Physical Form";
      break;
    case "/cml-report":
      HeaderName = "CML Report";
      break;
    case "/advance-tax-report":
      HeaderName = "Advance Tax Report";
      break;
    case "/agts-report":
      HeaderName = "AGTS Report";
      break;
    case "/stt-report":
      HeaderName = "STT Report";
      break;
       case "/partner-payout":
      HeaderName = "Partner Payout";
      break;
       case "/financeupload":
      HeaderName = "Finance Upload";
      break;
       case "/apledgerreport":
      HeaderName = "AP Ledger Report";
      break;
      case "/itemised-margin-report":
      HeaderName= "Itemised Margin Report";
      break;
      case "/telecaller-id-update":
        HeaderName = "ID Updation Dashboard";
        break;

    case "/hufnre-application-dashboard":
      HeaderName = "HUF NRE Application Dashboard";
      break;

    default:
      HeaderName = "Header";
    // code block
  }
  return HeaderName;
};
export const OpenWindowWithPost = (url, windowoption, params) => {
  var form = document.createElement("form");
  form.setAttribute("method", "post");
  form.setAttribute("action", url);
  form.setAttribute("target", windowoption);
  for (var i in params) {
    if (params.hasOwnProperty(i)) {
      var input = document.createElement("input");
      input.type = "hidden";
      input.name = i;
      input.value = params[i];
      form.appendChild(input);
    }
  }
  document.body.appendChild(form);
  form.submit();
};

// not used will modify later
export const ErrorRedirectLoginPage = (err) => {
  // debugger
  if (err.request.status == "401") {
    // debugger
    // localStorage.clear("");
    // navigate("/login");
  } else {
  }
};

export const getSearchParameters = () => {
  var prmstr = window.location.search.substr(1);
  return prmstr != null && prmstr != "" ? transformToAssocArray(prmstr) : {};
};
export const transformToAssocArray = (prmstr) => {
  var params = {};
  var prmarr = prmstr.split("&");
  for (var i = 0; i < prmarr.length; i++) {
    var tmparr = prmarr[i].split("=");
    params[tmparr[0].toLowerCase()] = tmparr[1];
  }
  return params;
};

export const inputPanVal = (e) => {
  let length = e.target.value.length;
  let enteredText = e.target.value.slice(-1);
  let existingValue = e.target.value.slice(0, length - 1);
  let aplhaRegex = /^[a-zA-Z]$/;
  let NumberRegex = /^[0-9]$/;

  if (length <= 5) {
    if (!enteredText.match(aplhaRegex)) {
      e.target.value = existingValue;
    }
  } else if (length <= 9) {
    if (!enteredText.match(NumberRegex)) {
      e.target.value = existingValue;
    }
  } else if (length <= 10) {
    if (!enteredText.match(aplhaRegex)) {
      e.target.value = existingValue;
    }
  } else {
    e.target.value = existingValue;
  }
};
export const onlyNumberEnter = (event) => {
  event.target.value = event.target.value.replace(/[^0-9]/g, "");
  event.target.value = Number(event.target.value);
};
export const lessThanNetRiskPayoutAmt = (event, netRiskAmt) => {
  if (event.target.value > netRiskAmt) {
    event.target.value = 0;
  }
  event.target.value = event.target.value.replace(/[^0-9]/g, "");
  event.target.value = Number(event.target.value);
};

export const getUrlExtension = (url) => {
  return url.split(/[#?]/)[0].split(".").pop().trim();
};

export const downloadPDF = (url, name) => {
  var xhr = new XMLHttpRequest();
  let format = getUrlExtension(url);
  xhr.open("GET", url, true);
  xhr.responseType = "blob";
  xhr.onload = function (e) {
    if (this.status == 200) {
      var myBlob = this.response;
      var link = document.createElement("a");
      link.href = window.URL.createObjectURL(myBlob);
      link.download = `${name}.${format}`;
      link.click();
    }
  };
  xhr.send();
};

export const handleDownloadDocument = async (url) => {
  // debugger
  // window.open(data);
  try {
    const response = await axios.get(
      url,
      { responseType: "blob" },
      { headers: { "Access-Control-Allow-Origin": "*" } }
    );
    const blob = new Blob([response.data]);
    const fileName = url.substring(url.lastIndexOf("/") + 1);
    let subIndex = fileName.indexOf("?");
    let SubFilename = fileName.substring(0, subIndex);
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = downloadUrl;
    a.download = SubFilename;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
  } catch (error) {
    console.error(`Error downloading ${url}:`, error);
  }
};

export const handleDownloadDocumentFrench = async (url, name, type) => {
  console.log(url, name, type, "checkMethod");
  
  try {
    const response = await axios.get(
      url,
      { responseType: "blob" },
      { headers: { "Access-Control-Allow-Origin": "*" } }
    );
    const blob = new Blob([response.data]);
    const fileNameFromUrl = url.substring(url.lastIndexOf("/") + 1).split("?")[0];
    const extension = fileNameFromUrl.split(".").pop();
    let fileName;

    if (type == "10") {
      fileName = `selfie.${extension}`;
    } else if (name && name.trim() !== "") {
      fileName = name;
    } else {
      fileName = fileNameFromUrl;
    }

    // const fileName  = name || fileNameFromUrl;
    const downloadUrl = window.URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.style.display = "none";
    a.href = downloadUrl;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    window.URL.revokeObjectURL(downloadUrl);
    document.body.removeChild(a);
  } catch (error) {
    console.error(`Error downloading ${url}:`, error);
  }
};
export const onlyNumberUpTo100 = (e) => {
  let length = e.target.value.length;
  let existingValue = e.target.value.slice(0, length - 1);
  let regex2 = /^(\d{0,2}(\.\d{1,2})?|100?)$/;
  if (!e.target.value.match(regex2)) {
    e.target.value = existingValue;
  }
};
export const onlyAlphaNumeric = (e) => {
  let length = e.target.value.length;
  let existingValue = e.target.value.slice(0, length - 1);
  let regex1 = /[A-Za-z0-9]$/;
  if (!e.target.value.match(regex1)) {
    e.target.value = existingValue;
  }
};
export const ZeroPrefix = (number) => {
  let PrefixedNumber;
  if (parseInt(number) < 10 && !`${number}`.startsWith("0")) {
    PrefixedNumber = `0${number}`;
  } else {
    PrefixedNumber = number;
  }
  return PrefixedNumber;
};
export const maxDateSet = (subtractYear = 0) => {
  let CurrentDate = new Date();
  let MinorDateSet = CurrentDate.setFullYear(
    CurrentDate.getFullYear() - subtractYear
  );
  let MinorFormat = new Date(MinorDateSet);
  let [day, month, year] = [
    MinorFormat.getDate(),
    MinorFormat.getMonth() + 1,
    MinorFormat.getFullYear(),
  ];

  month = ZeroPrefix(month);
  day = ZeroPrefix(day);
  return `${year}-${month}-${day}`;
};

export const DateGet = {
  maxToday: maxDateSet(),
  minTenyear: maxDateSet(10),
};
export const catchError = (data) => {
  if (data.request.status === 401) {
    // window.navigate(window.location.host)
    // // window.location.href = 'URL';
    window.history.back();
    // window.location.replace("/");
    // window.location = window.location.host;
    // window.location = window.location.protocol + "//" + window.location.host;
  }
};

export const getClientsRawData = async () => {
  try {
    const getList = await axios.get(
      AP_Payout_Rms.GetClientRawData_URL,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
        },
      }
    );
    const res = getList?.data;
    if (res?.status === 0) {
      window.open(res?.data, "_self", "noopener,noreferrer");
      toast.success("Excel download successfully");
    } else {
      toast.error(res?.message);
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.message);
  }
};


export const getPartnerRawData = async () => {
  try {
    const getList = await axios.get(
      Partner_Payout_Rms.GetPartnerRawData_URL,

      {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${localStorage.getItem("ssoToken")}`,
        },
      }
    );
    const res = getList?.data;
    if (res?.status === 0) {
      window.open(res?.data, "_self", "noopener,noreferrer");
      toast.success("Excel download successfully");
    } else {
      toast.error(res?.message);
    }
  } catch (error) {
    console.log(error);
    toast.error(error?.message);
  }
};

// export const validatePan = (values) => {
//   var k = values.charCode;
//   if (values.target.value.length >= 0 && values.target.value.length < 5) {
//     if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8) {
//       return true;
//     } else {
//       values.preventDefault();
//     }
//   }
//   if (values.target.value.length >= 5 && values.target.value.length < 9) {
//     if ((k >= 48 && k <= 57) || k === 8) {
//       return true;
//     } else {
//       values.preventDefault();
//     }
//   }
//   if (values.target.value.length >= 9 && values.target.value.length < 10) {
//     if ((k > 64 && k < 91) || (k > 96 && k < 123) || k === 8) {
//       return true;
//     } else {
//       values.preventDefault();
//     }
//   }
// };

export const validatePan = (e) => {
  const k = e.charCode;
  const cursorPos = e.target.selectionStart; // where user is typing

  // 1st to 3rd → Alphabets only
  if (cursorPos < 3) {
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122)) {
      return true;
    } else {
      e.preventDefault();
    }
  }

  // 4th → must be P (force uppercase)
  else if (cursorPos === 3) {
    if (k === 80 || k === 112) {
      // 'P' or 'p'
      return true;
    } else {
      e.preventDefault();
    }
  }

  // 5th → Alphabet
  else if (cursorPos === 4) {
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122)) {
      return true;
    } else {
      e.preventDefault();
    }
  }

  // 6th to 9th → Numbers only
  else if (cursorPos >= 5 && cursorPos < 9) {
    if (k >= 48 && k <= 57) {
      return true;
    } else {
      e.preventDefault();
    }
  }

  // 10th → Alphabet
  else if (cursorPos === 9) {
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122)) {
      return true;
    } else {
      e.preventDefault();
    }
  }
};

export const validateIFSC = (event) => {
  const k = event.charCode;
  const length = event.target.value.length;

  // Allow Backspace
  if (k === 8) return true;

  if (length < 4) {
    // First 4 must be alphabets
    if ((k >= 65 && k <= 90) || (k >= 97 && k <= 122)) {
      return true;
    } else {
      event.preventDefault();
    }
  } else if (length === 4) {
    // 5th must be "0"
    if (k === 48) {
      return true;
    } else {
      event.preventDefault();
    }
  } else if (length > 4 && length < 11) {
    // Last 6 must be alphanumeric
    if (
      (k >= 65 && k <= 90) || // A-Z
      (k >= 97 && k <= 122) || // a-z
      (k >= 48 && k <= 57) // 0-9
    ) {
      return true;
    } else {
      event.preventDefault();
    }
  } else {
    // Prevent typing beyond 11
    event.preventDefault();
  }
};

export const copyText = (e, id, ToolTipid) => {
  const responseElement = document.querySelector(id);

  if (responseElement) {
    // Concatenate opening and closing curly braces with text content
    const res = `{${responseElement.textContent.trim()}}`;
    const correctUrl = res.split("{")[1].split("}")[0];

    // Copy the modified text
    navigator.clipboard.writeText(correctUrl);

    // Show copy tooltip
    const toolTipElement = document.getElementById(ToolTipid);
    if (toolTipElement) {
      toolTipElement.style.display = "block";
      setTimeout(function () {
        toolTipElement.style.display = "none";
      }, 1000);
    }
  }
};

export const AESDecryption = (data) => {
  // const iv = "dCdGXZaOSMegBAHi";
  // const key = "YVTMmqbJG3qRxpJL";
  // const fkey = CryptoJS.enc.Utf8.parse(key);
  // const fiv = CryptoJS.enc.Utf8.parse(iv);
  const iv = getIV();
  const key = getSecret();
  const fkey = CryptoJS.enc.Utf8.parse(atob(key));
  const fiv = CryptoJS.enc.Utf8.parse(atob(iv));
  return CryptoJS.AES.decrypt(data, fkey, {
    iv: fiv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  }).toString(CryptoJS.enc.Utf8);
};

export const ApiResDecrypt = (data) => {
  let response = AESDecryption(data);
  return JSON.parse(JSON.parse(response));
};

export const decryptString = (data) => {
  return AESDecryption(data);
};


export const LoginResDecrypt = (data) => {
  let response = AESDecryption(data);
  return JSON.parse(response);
};
export const AESEncryption = (data) => {
  // const iv = "dCdGXZaOSMegBAHi";
  // const key = "YVTMmqbJG3qRxpJL";
  // const fkey = CryptoJS.enc.Utf8.parse(key);
  // const fiv = CryptoJS.enc.Utf8.parse(iv);
  const iv = getIV();
  const key = getSecret();
  const fkey = CryptoJS.enc.Utf8.parse(atob(key));
  const fiv = CryptoJS.enc.Utf8.parse(atob(iv));
  const jsonString = JSON.stringify(data);
  const encryptedData = CryptoJS.AES.encrypt(jsonString, fkey, {
    iv: fiv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
  });
  return encryptedData.toString();
};

export const decryptData = (data) => {
  const iv = CryptoJS.enc.Hex.parse(data.substr(0, 32));
  const ct = CryptoJS.enc.Hex.parse(data.substr(32));
  const key = CryptoJS.enc.Utf8.parse("6368616e676520746869732070617373");
  const decrypted = CryptoJS.AES.decrypt({ ciphertext: ct }, key, {
    mode: CryptoJS.mode.CBC,
    iv: iv,
  });
  return decrypted.toString(CryptoJS.enc.Utf8);
};

export const encryptData = (data) => {
  const key = CryptoJS.enc.Utf8.parse("6368616e676520746869732070617373");
  const iv = CryptoJS.lib.WordArray.random(16); // Generate a random IV
  const encrypted = CryptoJS.AES.encrypt(CryptoJS.enc.Utf8.parse(data), key, {
    mode: CryptoJS.mode.CBC,
    iv: iv,
    padding: CryptoJS.pad.Pkcs7,
  });
  const encryptedHex =
    iv.toString(CryptoJS.enc.Hex) +
    encrypted.ciphertext.toString(CryptoJS.enc.Hex);
  return encryptedHex;
};

export const downloadPDFNew = (url, name) => {
  const isMobileDevice = () => {
    return window.matchMedia("only screen and (max-width: 998px)").matches;
  };
  if (process.env.REACT_APP_DOMAIN === "PWA" && isMobileDevice()) {
    let format = getUrlExtension(url);
    let link = document.createElement("a");
    link.href = url;
    link.download = `${name}.${format}`;
    link.click();
  } else {
    let xhr = new XMLHttpRequest();
    let format = getUrlExtension(url);
    xhr.open("GET", url, true);
    xhr.responseType = "blob";
    xhr.onload = function (e) {
      if (this.status == 200) {
        let myBlob = this.response;
        let link = document.createElement("a");
        link.href = window.URL.createObjectURL(myBlob);
        link.download = `${name}.${format}`;
        link.click();
      }
    };
    xhr.send();
  }
};

export const nameValidation = (e) => {
  if (e.target.value.length >= 1) {
    if (e.target.value.charAt(0) === ".") {
      e.target.value = e.target.value.slice(1, e.target.value.length);
    }
  }
  e.target.value = e.target.value.trimStart();
  e.target.value = e.target.value.replace(/[^A-Za-z.\s]/g, "");
};
export const NameInput = (e) => {
  if (e.target.value.length >= 1) {
    if (e.target.value.charAt(0) === ".") {
      e.target.value = e.target.value.slice(1, e.target.value.length);
    }
  }
  e.target.value = e.target.value.trimStart();
  e.target.value = e.target.value.replace(/[^A-Za-z.\s]/g, "");
};

export const handlePanInput = (e) => {
  let value = e.target.value.toUpperCase();
  let filtered = "";
  for (let i = 0; i < value.length; i++) {
    const char = value[i];
    if (i < 5) {
      if (/[A-Z]/.test(char)) {
        filtered += char;
      }
    } else if (i >= 5 && i < 9) {
      if (/[0-9]/.test(char)) {
        filtered += char;
      }
    } else if (i === 9) {
      if (/[A-Z]/.test(char)) {
        filtered += char;
      }
    }
  }

  e.target.value = filtered;
};
export const NumberInput = (e) =>
  (e.target.value = e.target.value.replace(/[^0-9]/g, ""));

export const encryptPayloadValues = (payload) => {
  // const iv = "dCdGXZaOSMegBAHi";
  // const key = "YVTMmqbJG3qRxpJL";
  // const fkey = CryptoJS.enc.Utf8.parse(key);
  // const fiv = CryptoJS.enc.Utf8.parse(iv);
  const iv = getIV();
  const key = getSecret();
  const fkey = CryptoJS.enc.Utf8.parse(atob(key));
  const fiv = CryptoJS.enc.Utf8.parse(atob(iv));

  const encryptedPayload = {};

  Object.entries(payload).forEach(([key, value]) => {
    if (key === "IncomeFile" || value === "" || value === null || value === undefined) {
      encryptedPayload[key] = value;
    } else {
      const encryptedData = CryptoJS.AES.encrypt(
        typeof value === "string" ? value : JSON.stringify(value),
        fkey,
        {
          iv: fiv,
          mode: CryptoJS.mode.CBC,
          padding: CryptoJS.pad.Pkcs7,
        }
      ).toString();
      encryptedPayload[key] = encryptedData;
    }
  });

  return encryptedPayload;
};

export const formatDate = (dateString) => {
  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, '0');
  const month = String(date.getMonth() + 1).padStart(2, '0'); // getMonth() returns 0-based months
  const year = date.getFullYear();
  return `${day}-${month}-${year}`;
}

export const formatDateMonth = (dateString) => {
  if (dateString) {
    const value = { day: '2-digit', month: 'short', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', value).replace(',', '');
  }
  return "-"
};

export const copyTextNew = (e, id, ToolTipid, data) => {
  const responseElement = document.querySelector(id);
  const linkToCopy = data;

  if (linkToCopy) {
    navigator.clipboard.writeText(linkToCopy)
      .then(() => {
        // Show the copy tooltip for 1 second
        const toolTipElement = document.getElementById(ToolTipid);
        if (toolTipElement) {
          toolTipElement.textContent = `${linkToCopy}`; // Optional: Show the copied link in the tooltip
          toolTipElement.style.display = "block";
          setTimeout(() => {
            toolTipElement.style.display = "none";
          }, 2000);
        }
      })

      .catch(err => {
        console.error("Error copying text to clipboard: ", err);
      });
  }
};
export function getCurrentFinancialYear(strDocDate) {
  let startYear = "";
  let endYear = "";
  let docDate = new Date(strDocDate);
  if ((docDate.getMonth() + 1) <= 3) {
    startYear = docDate.getFullYear() - 1;
    endYear = docDate.getFullYear();
  } else {
    startYear = docDate.getFullYear();
    endYear = docDate.getFullYear() + 1;
  }
  return { startDate: '01/Apr/' + startYear, endDate: '31/Mar/' + endYear, startYear: startYear, endYear: endYear };
}

export function formatNumber(value) {
  if (value === undefined || value === null) {
    return "0";
  }
  const decimalPart = value?.toString()?.split('.')[1];
  // Check if there are more than 2 digits after the decimal
  if (decimalPart && decimalPart.length > 2) {
    return value.toFixed(2);
  }
  return value.toString();
}

export function formatNumberDec(value) {
  if (value === undefined || value === null) {
    return "0";
  }
  const num = parseFloat(value);
  if (isNaN(num)) return value; // If not a number, return as-is

  const decimalPart = value.toString().split('.')[1];
  if (decimalPart && decimalPart.length > 2) {
    return num.toFixed(2);
  }
  return num.toString();
}

export const mobileNumberEnc = (value) => {
  if (value) {
    let numberToshow = value.slice(-4);
    let lenthtoX = Array(value?.length - 3).join("x");
    return lenthtoX + numberToshow;
  }
};

export const splitDateNewSlash = (createddatetime) => {
  let date = createddatetime?.split("T")[0];
  return date?.split("-")?.reverse()?.join("/");
};

export const validateIfsc = (ifsc) => {
  let ifscRegex = /^[A-Za-z]{4}[a-zA-Z0-9]{7}$/
  if (ifsc.length > 0) {
    return ifscRegex.test(ifsc)
  } else {
    return false;
  }
}

export const maskEmail = (email) => {
  if (!email || !email.includes("@")) {
    return email;
  }

  const [localPart, domain] = email.split("@");

  // Handle the case where localPart length is <= 2
  if (localPart.length <= 2) {
    return `${localPart[0]}*${localPart[localPart.length - 1]}@${domain}`;
  }

  if (localPart.length <= 5) {
    // Mask all but the first 2 characters for email parts with length <= 5
    const visible = localPart.slice(0, 2) + "*".repeat(localPart.length - 2);
    return `${visible}@${domain}`;
  }

  const start = localPart.slice(0, 3);
  const end = localPart.slice(-2);
  const masked = "*".repeat(localPart.length - 5);
  return `${start}${masked}${end}@${domain}`;
};


export const getFinancialYear = (offset = 0) => {
  const today = new Date();
  const year = today.getFullYear();
  const month = today.getMonth() + 1;

  let baseStartYear = month >= 4 ? year : year - 1;

  const startDate = moment([baseStartYear + offset, 3, 1]).format("MM-DD-YYYY");
  const endDate = moment([baseStartYear + offset + 1, 2, 31]).format("MM-DD-YYYY");

  const startYearShort = startDate.slice(-2);
  const endYearShort = endDate.slice(-2);

  return {
    startDate,
    endDate,
    label: `FY ${startYearShort}-${endYearShort}`,
  };
};

export const safeDecryptString = (data) => {
  if (!data || typeof data !== "string") return "";

  // 🔐 Base64 encrypted strings usually end with '='
  const looksEncrypted =
    /^[A-Za-z0-9+/]+=*$/.test(data) && data.length % 4 === 0;

  if (!looksEncrypted) {
    // Already masked or plain text
    return data;
  }

  try {
    const decrypted = AESDecryption(data);
    return decrypted || data;
  } catch (err) {
    console.warn("Decryption failed, using raw value:", data);
    return data;
  }
};

export const noDataIBA = (noData = "No Data Available") => {
  return (
    <div className="no-data-iba">
      <img src={noDataIcon} alt="No Data Icon" />
      <span>{noData}</span>
    </div>
  );
};

export const validateISIN = (value) => {
  if (!value) return "ISIN is required";

  if (value.length !== 12) {
    return "ISIN must be exactly 12 characters";
  }

  if (!/^INE[A-Z0-9]{9}$/.test(value)) {
    return "ISIN must start with 'INE' and be valid format";
  }

  return "";
};

const ALPHANUMERICSRIP_REGEX = /^[a-zA-Z0-9\-()\s]$/;

export const scripInput = (e) => {
  const allowedKeys = [
    "Backspace",
    "Delete",
    "ArrowLeft",
    "ArrowRight",
    "Tab",
  ];

  if (allowedKeys.includes(e.key)) return;

  if (!ALPHANUMERICSRIP_REGEX.test(e.key)) {
    e.preventDefault();
    return;
  }

  if (e.key === " ") {
    const value = e.target.value;
    const cursorPos = e.target.selectionStart;

    // Prevent leading space
    if (cursorPos === 0) {
      e.preventDefault();
      return;
    }

    // Prevent double space
    if (value[cursorPos - 1] === " ") {
      e.preventDefault();
      return;
    }
  }
};

export const alphaNumericUppercase = (
  value = "",
  maxLength = 50
) => {
   return value
    .toUpperCase()
    .replace(/[^A-Z0-9\s]/g, "")
    .replace(/\s+/g, " ")
    .trimStart()
    .slice(0, maxLength);
};

export const alphaNumericUppercasePaste =
  (maxLength = 50) =>
  (e) => {
    e.preventDefault();

    const pastedText = e.clipboardData.getData("text");

    const cleanedValue = pastedText
      .toUpperCase()
      .replace(/[^A-Z0-9\s]/g, "")
      .replace(/\s+/g, " ")
      .trimStart()
      .slice(0, maxLength);

    const input = e.target;

    const start = input.selectionStart ?? 0;
    const end = input.selectionEnd ?? 0;

    const currentValue = input.value || "";

    const newValue = (
      currentValue.slice(0, start) +
      cleanedValue +
      currentValue.slice(end)
    )
      .replace(/\s+/g, " ")
      .trim()
      .slice(0, maxLength);

    const nativeSetter = Object.getOwnPropertyDescriptor(
      window.HTMLInputElement.prototype,
      "value"
    ).set;

    nativeSetter.call(input, newValue);

    input.dispatchEvent(new Event("input", { bubbles: true }));
    input.dispatchEvent(new Event("change", { bubbles: true }));

    const cursorPos = Math.min(
      start + cleanedValue.length,
      maxLength
    );

    setTimeout(() => {
      input.setSelectionRange(cursorPos, cursorPos);
    });
  };

export const getInitials = (name = "") => {
  const words = name.trim().split(/\s+/);

  if (words.length === 1) {
    return words[0][0]?.toUpperCase() || "";
  }

  return (
    (words[0][0] || "") +
    (words[words.length - 1][0] || "")
  ).toUpperCase();
};

export const sortTableData = (
  data,
  field,
  direction = "asc",
  type = "string"
) => {
  return [...data].sort((a, b) => {
    let valueA = a[field];
    let valueB = b[field];

    switch (type) {
      case "number":
        valueA = Number(valueA || 0);
        valueB = Number(valueB || 0);
        break;

      case "date":
        valueA = new Date(valueA);
        valueB = new Date(valueB);
        break;

      default:
        valueA = String(valueA || "").toUpperCase();
        valueB = String(valueB || "").toUpperCase();
    }

    if (valueA < valueB) return direction === "asc" ? -1 : 1;
    if (valueA > valueB) return direction === "asc" ? 1 : -1;

    return 0;
  });
};

export const toTitleCase = (str = "") => {
  return str
    .toLowerCase()
    .split(" ")
    .filter(Boolean)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const handlePasteText =
  ({
    value,
    setValue,
    maxLength = 100,
    regex = /[^A-Z0-9\s]/g,
    transform = (text) => text.toUpperCase(),
  }) =>
  (e) => {
    e.preventDefault();

    let clean = transform(e.clipboardData.getData("text"))
      .replace(regex, "")
      .replace(/\s+/g, " ")
      .trim();

    if (!clean) return;

    const input = e.target;
    const start = input.selectionStart;
    const end = input.selectionEnd;

    const newValue = (
      value.slice(0, start) +
      clean +
      value.slice(end)
    ).slice(0, maxLength);

    setValue(newValue);

    const cursorPos = Math.min(start + clean.length, maxLength);

    setTimeout(() => {
      input.setSelectionRange(cursorPos, cursorPos);
    }, 0);
  };
